import { useDispatch } from 'react-redux';

import { actions } from 'src/redux/productMediaCarousel/slice';
import type { AppThunkDispatch } from 'src/redux/store';
import type { ProductMediaModalDispatchProps } from './ProductMediaModal';

export const useProductMediaModalActions = (): ProductMediaModalDispatchProps => {
  const dispatch = useDispatch<AppThunkDispatch>();

  return {
    closeModal: () => dispatch(actions.closeModal()),
    onNextMedia: (payload) => dispatch(actions.nextMedia(payload)),
    onPrevMedia: (payload) => dispatch(actions.prevMedia(payload)),
    setCurrentMedia: (payload) => dispatch(actions.setCurrentMedia(payload)),
  };
};
